import { connect } from 'react-redux'

import MainLogo from './MainLogo'

import { getIdentityActiveRoleName, getIdentityOrganization } from 'store/entities/identity/selectors'

const mapStateToProps = state => ({
  organization: getIdentityOrganization(state),
  roleName: getIdentityActiveRoleName(state),
})

export default connect(mapStateToProps)(MainLogo)
